import React, { useEffect, useRef, useState } from 'react';
import { Chevron } from '@/assets/images';
import './Dropdown.scss';

export interface ListItem {
	title: string;
	borderColor?: 'red' | 'green' | 'none';
	id?: number;
}

interface Props {
	title: string;
	headerColor: 'light' | 'medium' | 'dark';
	dropdownColor: 'light' | 'medium' | 'dark';
	list: ListItem[];
	setLead?: (arg0: string) => void;
	width?: string;
	handleClick?: (item: ListItem) => void;
	disabled?: boolean;
	listClassName?: string;
}

const Dropdown = ({
	title,
	headerColor,
	dropdownColor,
	list,
	setLead,
	width = '126px',
	handleClick,
	disabled = false,
	listClassName = ''
}: Props): JSX.Element => {
	const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
	const [headerTitle, setHeaderTitle] = useState<string>(title);
	const [borderColor, setBorderColor] = useState<string>('');
	const [selectedItemId, setSelectedItemId] = useState<number | undefined>(0);
	const dropdownRef = useRef<HTMLDivElement>(null);

	const selectItem = (item: ListItem) => {
		setHeaderTitle(item.title);
		setIsDropdownOpen(false);
		setSelectedItemId(item.id);

		if (item.borderColor) {
			setBorderColor(item.borderColor);
		} else {
			setBorderColor('');
		}
	};

	useEffect(() => {
		setHeaderTitle(title);
		if (title === 'Lead') {
			selectItem({ id: 1, title: 'Lead', borderColor: 'green' });
		} else if (title === 'No Lead') {
			selectItem({ id: 2, title: 'No Lead', borderColor: 'red' });
		} else if (title === 'Lead Status') {
			selectItem({ id: 3, title: 'Lead Status', borderColor: 'none' });
		}
	}, [title]);

	const closeDropdown = (e: any) => {
		if (!dropdownRef?.current?.contains(e.target)) {
			setIsDropdownOpen(false);
		}
	};

	useEffect(() => {
		window.addEventListener('click', closeDropdown);

		return () => window.removeEventListener('click', closeDropdown);
	}, []);

	return (
		<div style={{ width }} className="dropdown-wrapper">
			<div
				style={{ width }}
				className={`dropdown-header ${
					disabled ? 'cursor-default' : 'cursor-pointer'
				} ${headerColor} ${borderColor}`}
				onClick={() => {
					if (disabled) return;
					setIsDropdownOpen(!isDropdownOpen);
				}}
				ref={dropdownRef}
			>
				<span className="dropdown-header-text">{headerTitle}</span>
				<Chevron
					className={`dropdown-icon ${
						isDropdownOpen ? 'flipped' : ''
					}`}
				/>
			</div>
			<ul
				style={{ width }}
				className={`dropdown-list ${dropdownColor} ${
					isDropdownOpen ? '' : 'hide'
				} ${listClassName}`}
			>
				{list.map((item, i) => (
					<li
						key={item.id || i}
						className={`dropdown-list-element ${dropdownColor} ${
							item.id === selectedItemId ? 'selected' : ''
						}`}
						onClick={e => {
							e.stopPropagation();
							selectItem(item);
							handleClick && handleClick(item);
							if (setLead) {
								setLead(item.title);
							}
						}}
					>
						{item.title}
					</li>
				))}
			</ul>
		</div>
	);
};

export default Dropdown;
